<template>
  <div class="container">
    <div class="content">
      <div class="carousel">
        <div class="box">
          <img @click="imagesShowHander" :src="src" alt="" />
        </div>
        <div class="btn left" @click="changeData(0)">
          <span>
            <i class="el-icon-caret-left"></i>
          </span>
        </div>
        <div class="btn right" @click="changeData(1)">
          <span>
            <i class="el-icon-caret-right"></i>
          </span>
        </div>
      </div>
    </div>
    <div v-show="imagesShow" class="imagesShow" @mousewheel="showMouseWheel">
      <div class="imagesShow_container">
        <img
          src="../../assets/images/关闭.png"
          title="关闭"
          alt=""
          class="imagesShow_close"
          @click="imagesShowHander"
        />
        <img
          :src="showSrc"
          class="imagesShow_image"
          alt=""
          @mousedown="showMouseDown"
          @mouseup="showMouseUp"
          @mousewheel="showMouseWheel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import HeaderB from "@/components/public/headerB";
import Code from "@/components/public/code";
import Footer from "@/components/public/footer";
export default {
  data() {
    return {
      toHeaderB: {
        title: "总体规划",
        parent: "走进湿地",
        parentLink: "/stepInWetland/stepInWetland",
        child: "总体规划",
        childLink: "/stepInWetland/stepInWetland",
        longTop: "",
        longBottom: "",
        shortValue: "Master Plan",
        isLong: false,
        titleShow: false,
        logoSrc: {}
      },
      src: "",
      showSrc: "",
      imagesShow: false,
      start: 1,
      max: null,
      imagesFlag: false,
      scale: 1
    };
  },
  components: {
    HeaderB,
    Code,
    Footer
  },
  methods: {
    // 左右按钮切换数据
    changeData(index) {
      this.scale = 1;
      $(".imagesShow_image").css({
        "margin-left": "0",
        "margin-top": "0",
        transform: "translate(-50%, -50%) scale(1)"
      });
      this.src = "";
      this.showSrc = "";
      this.toHeaderB.titleShow = false;
      if (index === 0) {
        this.start--;
        if (this.start <= 0) {
          this.start = this.max;
        }
      } else {
        this.start++;
        if (this.start > this.max) {
          this.start = 1;
        }
      }
      // 左右切换获取数据
      this.getData();
    },
    // 显示与隐藏大图
    imagesShowHander() {
      this.scale = 1;
      $(".imagesShow_image").css({
        "margin-left": "0",
        "margin-top": "0",
        transform: "translate(-50%, -50%) scale(1)"
      });
      this.imagesShow ? (this.imagesShow = false) : (this.imagesShow = true);
    },
    // 大图按下移动
    showMouseDown(event) {
      event = event || window.event;
      let target = event.target;
      let img = $(".imagesShow_image");
      let left =
        img.css("margin-left").substr(0, img.css("margin-left").length - 2) - 0;
      let top =
        img.css("margin-top").substr(0, img.css("margin-top").length - 2) - 0;
      let x = event.clientX - left;
      let y = event.clientY - top;
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }
      document.onmousemove = function(e) {
        img.css("margin-left", e.clientX - x + "px");
        img.css("margin-top", e.clientY - y + "px");
      };
    },
    // 大图抬起
    showMouseUp() {
      document.onmousemove = null;
    },
    showMouseWheel(e) {
      let img = $(".imagesShow_image");
      //阻止滚动条滚动
      function scrollFunc(e) {
        e = e || window.event;
        if (e && e.preventDefault) {
          e.preventDefault();
          e.stopPropagation();
        } else {
          e.returnvalue = false;
          return false;
        }
      }
      scrollFunc();
      if (e.wheelDelta > 0) {
        this.scale = (this.scale + 0.1).toFixed(1) - 0;
      } else {
        if (this.scale > 0.1) {
          this.scale = (this.scale - 0.1).toFixed(1) - 0;
        }
      }
      img.css(
        "transform",
        "translate(-50%, -50%) scale(" + this.scale.toFixed(1) + ")"
      );
    },
    // 获取数据
    getData() {
      this.axios
        .get(this.$store.state.Url10 + "masterplay/findMasterPlayList", {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            soId: this.$store.state.Soid,
            startPage: this.start,
            limit: 1,
            type: 0
          }
        })
        .then(data => {
          // this.max = data.data.total - 1;
          this.max = data.data.total;
          data = data.data.data[0];
          this.src = this.$store.state.Url10 + data.attLessList[0];
          this.showSrc = this.$store.state.Url10 + data.attList[0].uaPath;
          this.toHeaderB.titleShow = true;

          document.documentElement.scrollTop = 300;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    // 动态计算高度
    $(".box").css("height", $(window).height() - $(".footer").height() - 88);
    // 滚动条自动滚到底部
    // const height = $(document).height() - $(window).height();
    // $(document).scrollTop(height);
    // 放大缩略图
    $(".imagesShow_image").css({ height: "100%" });
    // 页面加载时获取数据
    this.getData();
    setTimeout(function() {
      $(".header_nav li")
        .eq(1)
        .find("span")
        .find("a")
        .attr("class", "header_native");
    }, 0);
  }
};
</script>

<style scoped="scoped">
.content {
  padding-bottom: 0;
}
.carousel {
  position: relative;
  overflow: hidden;
}
.carousel img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}
.btn {
  position: absolute;
  top: 50%;
  width: 40px;
  height: 50px;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  line-height: 50px;
  cursor: pointer;
}
.left {
  left: 0;
}
.right {
  right: 0;
}
.btn span {
  color: white;
  display: inline-block;
  position: absolute;
  font-size: 40px;
  top: 1%;
}
.left span {
  left: 0;
}
.right span {
  left: 0;
}
.imagesShow {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 666;
}
.imagesShow_container {
  position: relative;
  height: 100%;
}
.imagesShow_close {
  position: absolute;
  top: 0;
  right: -2px;
  z-index: 666;
  cursor: pointer;
}
.imagesShow_image {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1);
  z-index: 33;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/stepInWetland/stepInWetland.vue